class SectionNavigation extends HTMLElement {
  constructor() {
    super();

    this.headerHeight = document.querySelector('.header-section').getBoundingClientRect().height
    this.height = this.getBoundingClientRect().height

    this.sections = Array.from(document.querySelectorAll('[data-navigable-heading]')).filter(section => section.id != '');
    this.buttons = this.querySelectorAll('[data-section-button]')

    this.buttons.forEach(button => {
      button.addEventListener('click', e => {
        e.preventDefault()
        this.goToSection(e.target.hash)
      })
    })

  }
  
  connectedCallback() {
    if (this.buttons.length == 0 || this.sections.length == 0) return

    this.listenScroll()
  }

  toggleCurrent(buttonIndex) {
    this.buttons.forEach(el => el.classList.add('button--tertiary'))
    buttonIndex !== null && this.buttons[buttonIndex].classList.remove('button--tertiary')
  }

  listenScroll() {
    window.addEventListener('scroll', () => {
      this.headerHeight = document.querySelector('.header-section').getBoundingClientRect().height
      this.height = this.getBoundingClientRect().height
      const currentSectionIndex = this.sections.findIndex(section => section.getBoundingClientRect().top > this.height + this.headerHeight)

      switch(currentSectionIndex) {
        case (-1):
          this.toggleCurrent(this.buttons.length - 1)
          break
        case 0:
          this.toggleCurrent(null)
          break
        default:
          this.toggleCurrent(currentSectionIndex - 1)

      }
    })
  }

  goToSection(id) {
    const target = document.getElementById(id.slice(1))
    if (target == undefined) return
    
    window.scrollTo({
      top: target.getBoundingClientRect().top + window.scrollY - this.height - this.headerHeight + 1,
      behavior: 'smooth'
    })
  }

}
if (!customElements.get('section-navigation')) customElements.define('section-navigation', SectionNavigation);